import { getActiveOrganization } from '@edge/spark/io-roles'
import { type QueryResolvers } from '../../../../../generated/graphql'

export const activeOrganizationResolver: QueryResolvers['activeOrganization'] = async () => {
    const org = await getActiveOrganization()

    if (!org) {
        console.debug('activeOrganizationResolver > Missing Active Organization')
        return {}
    }

    return org
}
